import React, { ReactNode, useRef } from 'react';
import { Button } from '~/UIKit';
import { SportCategoryList } from '~/Components/SportCategoryList';
import { CHARCOAL_GREY, GREY } from '~/Constants/Colors.constants';
import { useBoolean } from '~/Hooks';
import { ChevronRight } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { selectSportCategoryTypeList } from '~/store/events';
import { makeStyles } from '~/UIKit/Style';
import { useSportCatgeroy } from '~/Helpers/SportCategory';
interface SportCategoryTypeSelectionInputProps {
  selectedSportCategoryType: number;
  children: ReactNode;
  updateSportCategoryType: (type: number) => void;
  disabled?: boolean;
}

const useStyles = (catSelected: boolean) =>
  makeStyles(() => ({
    SportCategoryTypeSelectionInputWrapper: {
      display: 'flex',
    },
    button: {
      color: catSelected ? CHARCOAL_GREY : GREY,
      fontWeight: 'normal',
      marginLeft: 'auto',
      paddingRight: 0,
      marginRight: '-8px',
    },
    ChevronRight: {
      color: GREY,
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit',
    },
  }));

export const SportTypeSelectionInput = ({
  children,
  selectedSportCategoryType,
  updateSportCategoryType,
  disabled,
}: SportCategoryTypeSelectionInputProps) => {
  const { classes } = useStyles(!!selectedSportCategoryType)();
  const { state: isOpen, setTrue: setOpen, setFalse: setClose } = useBoolean(false);
  const sportCategories = useSelector(selectSportCategoryTypeList);
  const { getCategory } = useSportCatgeroy();
  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <div
      className={classes.SportCategoryTypeSelectionInputWrapper}
      data-testid="sportcategorytypeselectioninput-wrapper"
    >
      <Button
        type="button"
        className={classes.button}
        onClick={setOpen}
        disabled={disabled}
        data-testid="sportcategorytypeselectioninput-button"
        ref={buttonRef}
      >
        {selectedSportCategoryType ? getCategory(selectedSportCategoryType) : children}
        <span className={classes.ChevronRight}>
          <ChevronRight />
        </span>
      </Button>
      <SportCategoryList
        open={isOpen}
        onClose={setClose}
        updateSportCategoryType={updateSportCategoryType}
        selectedSportCategoryType={selectedSportCategoryType}
        data-testid="sportcategorytypeselectioninput-modal"
        anchorEl={buttonRef.current}
        sportCategories={sportCategories}
      />
    </div>
  );
};
